import { useQuery } from '@tanstack/react-query'
import L from 'leaflet'

import {
  getPhysiologicalDiagnosesMap,
  GetPhysiologicalDiagnosesMapResponse,
} from '@/services/get-physiological-diagnoses-map'

export type UseGetPhysiologicalDiagnosesMapResponse = ReturnType<
  typeof useGetPhysiologicalDiagnosesMap
>['data']
interface UseGetPhysiologicalDiagnosesMapOptions {
  onError?: () => void
  enabled?: boolean
}

export const GET_PHYSIOLOGICAL_DIAGNOSES_MAP_QUERY =
  'GET_PHYSIOLOGICAL_DIAGNOSES_MAP_QUERY'

const getGeoJsonBounds = (
  diagnoses: GetPhysiologicalDiagnosesMapResponse['layers'],
) => {
  const geoJsonBounds = L.geoJSON(diagnoses).getBounds()

  return geoJsonBounds?.pad(0.5)
}

export const useGetPhysiologicalDiagnosesMap = (
  id: string,
  options?: UseGetPhysiologicalDiagnosesMapOptions,
) => {
  const query = useQuery(
    [GET_PHYSIOLOGICAL_DIAGNOSES_MAP_QUERY, id],
    async ({ signal }) => {
      const data = await getPhysiologicalDiagnosesMap(id, {
        signal,
      })

      const geoJsonBounds = getGeoJsonBounds(data.layers)

      return {
        geoJsonBounds,
        ...data,
      }
    },
    {
      cacheTime: 0,
      ...options,
    },
  )

  return query
}
